import { ApiProperty } from "@nestjs/swagger";


export class VendorDto {

    @ApiProperty()
    id: number

    @ApiProperty()
    vendorName: string;

    @ApiProperty()
    vendorCode: string;

    @ApiProperty()
    vendorType: string;
    @ApiProperty()
    gstNumber: string;

    @ApiProperty()
    contactPerson: string;

    @ApiProperty()
    phoneNumber: string;

    @ApiProperty()
    plantId: number;

    @ApiProperty()
    address: string;

    @ApiProperty()
    isActive: boolean;

    @ApiProperty()
    createdUser: string | null;

    @ApiProperty()
    createdAt: Date;

    @ApiProperty()
    updatedUser: string | null;

    @ApiProperty()
    updatedAt: Date;

    @ApiProperty()
    versionFlag: number;


}